import { render, staticRenderFns } from "./DistrictSelect.vue?vue&type=template&id=7a2c9ae0&"
import script from "./DistrictSelect.vue?vue&type=script&lang=ts&"
export * from "./DistrictSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports